import { connect } from 'react-redux';
import Component from './component';


const mapStateToProps = ({ loadingOverlay }) => ({
  ...loadingOverlay,
});


export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/main/loading-overlay/index.js